import React from 'react';
import { Button } from './Button';
import { Tooltip } from './Tooltip';
import { BarChart2Icon, PieChartIcon, LineChartIcon, DownloadIcon, ShareIcon, FilterIcon, RefreshCwIcon, MaximizeIcon } from 'lucide-react';
interface ChartControlsProps {
  activeView: string;
  onViewChange: (view: string) => void;
  onDownload?: () => void;
  onRefresh?: () => void;
  onExpand?: () => void;
  viewOptions?: Array<{
    id: string;
    label: string;
    icon: React.ReactNode;
    tooltip?: string;
  }>;
  className?: string;
}
export function ChartControls({
  activeView,
  onViewChange,
  onDownload,
  onRefresh,
  onExpand,
  viewOptions = [{
    id: 'type',
    label: 'By Type',
    icon: <PieChartIcon size={16} data-id="element-775" />,
    tooltip: 'View expenses by category'
  }, {
    id: 'date',
    label: 'By Date',
    icon: <BarChart2Icon size={16} data-id="element-776" />,
    tooltip: 'View expenses over time'
  }],
  className = ''
}: ChartControlsProps) {
  return <div className={`flex flex-wrap items-center gap-2 ${className}`} data-id="element-777">
      <div className="flex rounded-md overflow-hidden border border-gray-700" data-id="element-778">
        {viewOptions.map(option => <Tooltip key={option.id} content={option.tooltip || option.label} position="top" data-id="element-779">
            <button onClick={() => onViewChange(option.id)} className={`flex items-center px-3 py-1.5 text-sm transition-colors ${activeView === option.id ? 'bg-blue-900/50 text-blue-300 border-r border-blue-800' : 'bg-gray-700 text-gray-300 border-r border-gray-600 hover:bg-gray-650'} ${option.id === viewOptions[viewOptions.length - 1].id ? 'border-r-0' : ''}`} data-id="element-780">
              <span className="mr-1.5" data-id="element-781">{option.icon}</span>
              {option.label}
            </button>
          </Tooltip>)}
      </div>
      <div className="flex items-center ml-auto gap-1.5" data-id="element-782">
        {onRefresh && <Tooltip content="Refresh data" position="top" data-id="element-783">
            <Button variant="ghost" size="sm" onClick={onRefresh} className="text-gray-400 hover:text-gray-300" data-id="element-784">
              <RefreshCwIcon size={16} data-id="element-785" />
            </Button>
          </Tooltip>}
        {onDownload && <Tooltip content="Download as CSV" position="top" data-id="element-786">
            <Button variant="ghost" size="sm" onClick={onDownload} className="text-gray-400 hover:text-gray-300" data-id="element-787">
              <DownloadIcon size={16} data-id="element-788" />
            </Button>
          </Tooltip>}
        {onExpand && <Tooltip content="Expand chart" position="top" data-id="element-789">
            <Button variant="ghost" size="sm" onClick={onExpand} className="text-gray-400 hover:text-gray-300" data-id="element-790">
              <MaximizeIcon size={16} data-id="element-791" />
            </Button>
          </Tooltip>}
      </div>
    </div>;
}